import { render } from "./AddJob.vue?vue&type=template&id=25acded9&scoped=true"
import script from "./AddJob.vue?vue&type=script&lang=js"
export * from "./AddJob.vue?vue&type=script&lang=js"

import "./AddJob.vue?vue&type=style&index=0&id=25acded9&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25acded9"]])

export default __exports__